import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CarStatus } from '@upstart/harmony/lib/constants';
import DealerNav from '../../components/DealerNav';
import WidgetConfigEditor from '../../components/WidgetConfigEditor';
import SidebarContainer from '../SidebarContainer';
import widgetActions from '../../redux/widgets/actions';
import { getDealer } from '../../redux/dealers/selectors';
import WidgetService from '../../services/WidgetService';
import {
  getWidgetConfig,
  getWidgetConfigFetching,
} from '../../redux/widgets/selectors';
import ContentPage from '../ContentPage';
import PreviewButtonModal from '../../components/WidgetConfigEditor/PreviewButtonModal';
import { getWidgetButtonCssClass } from '../../util/constants';

// Dummy Preview Data
const CAR = {
  id: '4T1C31AK9LU527263',
  msrp: '15299',
  status: CarStatus.AVAILABLE,
};

class Buttons extends PureComponent {
  constructor() {
    super();
    this.state = { modalIsOpen: false };
  }

  componentDidMount() {
    const { dealerId } = this.props.match.params;
    this.props.actions.widgetConfigRequest({ dealerId });
  }

  onPageSave = (widgetConfig, opts) => {
    const { dealerId } = this.props.match.params;
    const dealer = { id: dealerId };
    const config = widgetConfig.config[opts.activeTab];
    // ADD PREVIEW DIALOG
    WidgetService.getButtonGroupsPreview({
      car: CAR,
      config,
      dealer,
    }).then(resp => {
      this.previewHTML = `<div class="prodigy-pricing-button-group">${
        resp.buttonGroups[CAR.id]
      }</div>`;
      this.previewCSS = resp.CSS;
      this.setState({ modalIsOpen: true });
    });
  };

  onStandaloneSave = widgetConfig => {
    const config = widgetConfig.config.STANDALONE;
    // ADD PREVIEW DIALOG
    WidgetService.getStandaloneButtonsPreview({
      config,
    }).then(resp => {
      this.previewHTML = Object.entries(resp.standaloneButtons)
        .map(
          ([key, value]) => `
          <div class="${getWidgetButtonCssClass(key)}">
            ${value}
          </div>`,
        )
        .join('');
      this.previewCSS = resp.CSS;
      this.setState({ modalIsOpen: true });
    });
  };

  setActiveTab = tab => {
    this.activeTab = tab;
  };

  saveConfig = (widgetConfig, dealer) => {
    const dealerId = dealer.id;
    this.props.actions.updateWidgetConfigRequest({
      dealerId,
      widgetConfig,
    });
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { dealer } = this.props;
    return (
      <SidebarContainer logo={dealer.logo} title={dealer.name}>
        <div className="dealers-table">
          <DealerNav />
          <WidgetConfigEditor
            dealer={dealer}
            onPageSave={this.onPageSave}
            onStandaloneSave={this.onStandaloneSave}
            fetching={this.props.fetching}
            onChange={this.props.actions.setWidgetConfig}
            widgetConfig={this.props.widgetConfig}
            setActiveTab={this.setActiveTab}
          />
          {this.state.modalIsOpen && (
            <PreviewButtonModal
              saveModal={() => {
                this.setState({ modalIsOpen: false });
                this.saveConfig(this.props.widgetConfig, dealer);
              }}
              cancelModal={() => this.setState({ modalIsOpen: false })}
              html={this.previewHTML}
              css={this.previewCSS}
              activeTab={this.activeTab}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

Buttons.propTypes = {
  fetching: PropTypes.bool,
  widgetConfig: PropTypes.object,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = state => ({
  dealer: getDealer(state),
  widgetConfig: getWidgetConfig(state),
  fetching: getWidgetConfigFetching(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...widgetActions }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPage(Buttons));
